import styles from './style.postcss';

import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import { replace } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'omni-common-ui';
import is from 'is_js';

import { actions as Group } from 'containers/Group';
import { actions as sessionPlansActions } from 'data/SessionPlans';
import {
  getCourseTypeFirstTab,
 } from './routes';

export class Homework extends Component {
  componentWillMount() {
    this.props.fetchSessionPlansIfNeeded(this.props.groupId);
    this._redirectByCourseType(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this._redirectByCourseType(nextProps);
  }

  _redirectByCourseType(props) {
    if (! props.location.pathname.endsWith('homework')) return;
    if (is.undefined(props.firstTabByCourseType)) return;
    this._redirectTo(props.firstTabByCourseType);
  }

  _redirectTo(pathname) {
    this.props.replacehRoute(this.props.buildRoute(
        `/group/${this.props.groupId}/homework/${pathname}`));
  }

  render() {
    return <div className={styles.Homework}>
      <div className={styles.Homework_wrapper}>
        {this.props.children}
      </div>
    </div>;
  }
}

Homework.propTypes = {
  groupId: PropTypes.string,
  isHFCourseTypeGroup: PropTypes.string,
  firstTabByCourseType: PropTypes.string,
  isSSV3HomeworkTab: PropTypes.func,
  isPracticePlayTab: PropTypes.func,
  children: PropTypes.node,
  fetchSessionPlansIfNeeded: PropTypes.func,
  replacehRoute: PropTypes.func.isRequired,
  buildRoute: PropTypes.func.isRequired,
};

export function mapStateToProps(state, ownProps) {
  const { groupId } = ownProps.params;
  const isHFCourseTypeGroup = Group.isHFCourseTypeGroup(state, groupId);
  const firstTabByCourseType = getCourseTypeFirstTab(state, groupId);

  return {
    groupId,
    isHFCourseTypeGroup,
    firstTabByCourseType,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    { replacehRoute: (path) => dispatch(replace(path)) },
    bindActionCreators(sessionPlansActions, dispatch)
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Homework);



// WEBPACK FOOTER //
// ./containers/Group/Homework/component.jsx